import { render } from "./deleteConfirm.vue?vue&type=template&id=f18455c0&scoped=true"
import script from "./deleteConfirm.vue?vue&type=script&lang=js"
export * from "./deleteConfirm.vue?vue&type=script&lang=js"

import "./deleteConfirm.vue?vue&type=style&index=0&id=f18455c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18455c0"]])

export default __exports__